// extracted by mini-css-extract-plugin
module.exports = {"photo":"FeedPhotoItem_photo__23f9f"};